export const API_PREFIX = '/api/v1';

export const PAGINATION = {
  defaultPage: 1,
  defaultPageSize: 24,
  maxPageSize: 100,
} as const;

export const PRODUCT_SORT = {
  RELEVANCE: 'relevance',
  FEATURED: 'featured',
  NEWEST: 'newest',
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc',
} as const;

/** Slug rules (spec section 13: human-readable slugs, redirect history). */
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .slice(0, 80)
    .replace(/^-|-$/g, '');
}

/** Categories shown in the header "Shop" dropdown and the mobile menu. */
export const SHOP_CATEGORIES = [
  { label: 'All Products', to: '/shop', blurb: 'The full catalogue' },
  { label: '3D Printing', to: '/c/3d-printing', blurb: 'Ready-made prints & custom services' },
  { label: 'DIY Kids Kits', to: '/c/diy-kids-kits', blurb: 'Supervised making, age-badged' },
  { label: 'Moulds', to: '/c/moulds', blurb: 'Ceramic, gypsum, concrete & candle' },
  { label: 'Candles', to: '/c/candles', blurb: 'Hand-poured & candle kits' },
  { label: 'Craft Supplies', to: '/c/craft-supplies', blurb: 'Filament, wax, tools & more' },
] as const;

/** Top-level links beside the Shop menu. */
export const PRIMARY_NAV = [
  { label: 'New Arrivals', to: '/new-arrivals' },
  { label: 'Collections', to: '/collections' },
  { label: 'Custom Orders', to: '/custom-orders' },
  { label: 'About', to: '/about' },
] as const;
